import React, { FormEvent } from "react";
import { SearchBoxProps } from "../../../models";
import { getLabelName } from "../../../utils";
import {TextBox,ButtonBox} from "../..";


export const SearchBoxGeneric: React.FC<SearchBoxProps> = ({
  searchFields,
  onChangeHandler,
  onSearchHandler,
  onResetHandler,
}) => {
  return (
      <div className="d-flex mb-4 flex-wrap align-items-center">
      {searchFields.map((field) => (
        <div
          key={field.key}
          className="me-3 d-flex align-items-center"
          style={{ width: 290 }}
        >
          <TextBox
            inputName={field.key}
            inputValue={field.value}
            onChange={(e: FormEvent<HTMLInputElement>) => {
                const target = e.currentTarget ?? (e.target as HTMLInputElement);
                const value = target?.value;
                onChangeHandler(field.key, value);
            }}
            labelName={getLabelName(field.label)}
            placeHolder={getLabelName(field.placeholder || field.key)}
          />
        </div>
      ))}
        <div className="col d-flex align-items-end justify-content-end mt-3">
        <ButtonBox
            iconType="account-search"
            className="btn-sm mx-2 btn-gradient-primary mb-3"
            size="sm"
            onClick={onSearchHandler}
        >
          {getLabelName("search")}
        </ButtonBox>
        <ButtonBox
            iconType="receipt"
            variant="danger"
            className="btn btn-sm mb-3"
            size="sm"
            onClick={onResetHandler}
        >
          {getLabelName("clear")}
        </ButtonBox>
      </div>
    </div>
  );
};
